import * as types from "./actionTypes";
import initialState from "reducers/initialState";

export const facilityItemReducer = (state = initialState.facilities.item, action) => {
  switch (action.type) {
    case types.LOAD_FACILITY_HEADER_STARTED: {
      const { key } = action;
      let result = { ...state };
      result[key] = {
        ...state[key],
        facilityReports: Object.assign([], { isLoaded: false }),
        loading: true,
        loaded: false
      };

      return result;
    }

    case types.LOAD_FACILITY_HEADER_SUCCEEDED: {
      const { key } = action;
      let result = { ...state };
      result[key] = {
        ...state[key],
        facilityReports: Object.assign([], { isLoaded: false }),
        loading: false,
        loaded: true
      };

      return result;
    }

    case types.LOAD_FACILITY_HEADER_FAILED: {
      const { key } = action;
      let result = { ...state };
      result[key] = {
        ...state[key],
        facilityReports: Object.assign([], { isLoaded: false }),
        loading: false,
        loaded: false
      };

      return result;
    }

    case types.FACILITY_HEADER_INVALIDATED: {
      let result = { ...state };
      result[action.event.eventBody.documentId] = {
        ...state[action.event.eventBody.documentId],
        loading: false,
        loaded: false
      };

      return result;
    }

    case types.EXECUTE_FACILITY_REPORTS_SUCCEEDED: {
      const { key, event } = action;
      let result = { ...state };
      result[key] = { ...state[key], facilityReports: Object.assign([], event.eventBody.list, { isLoaded: true }) };

      return result;
    }

    default:
      return state;
  }
};
